import moment from 'moment';

export const CURRENT_PERIOD_MONTH = moment().startOf('month').toDate();
export const MIN_PERIOD_MONTH = moment('2022-08-01').toDate();
